import * as d3 from 'd3';

export function drawPrairieGrills(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  offset = 0.15,
  lineColor = 'white',
  borderColor = 'black',
  borderWidth = 0.2, 
  grillThickness = 2,
  prairieDividers = 'standard', //verticals_only, horizontals_only
) {
  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  const offsetX = glassWidth * offset;
  const offsetY = glassHeight * offset;

  // Vertical side grills (left and right)
  if (prairieDividers !== 'horizontals_only') {
    [offsetX, glassWidth - offsetX].forEach((gx) => {
      svg.append('rect')
        .attr('x', glassX + gx - grillThickness / 2)
        .attr('y', glassY)
        .attr('width', grillThickness)
        .attr('height', glassHeight)
        .attr('fill', lineColor)
        .attr('stroke', borderColor)
        .attr('stroke-width', borderWidth);
    });
  }

  // Horizontal top/bottom grills
  if (prairieDividers !== 'verticals_only') {
    [offsetY, glassHeight - offsetY].forEach((gy) => {
      svg.append('rect')
        .attr('x', glassX)
        .attr('y', glassY + gy - grillThickness / 2)
        .attr('width', glassWidth)
        .attr('height', grillThickness)
        .attr('fill', lineColor)
        .attr('stroke', borderColor)
        .attr('stroke-width', borderWidth);
    });
  }
}

export function drawPrairieGrills1(svg, x, y, width, height, frameWidth = 10, offset = 0.15, lineColor = 'white', grillThickness = 2) {

  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  const offsetX = glassWidth * offset;
  const offsetY = glassHeight * offset;

  // Vertical side grills (left and right)
  [offsetX, glassWidth - offsetX].forEach((gx) => {
    svg.append('rect')
      .attr('x', glassX + gx - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', glassHeight)
      .attr('fill', lineColor);
  });

  // Horizontal top/bottom grills
  [offsetY, glassHeight - offsetY].forEach((gy) => {
    svg.append('rect')
      .attr('x', glassX)
      .attr('y', glassY + gy - grillThickness / 2)
      .attr('width', glassWidth)
      .attr('height', grillThickness)
      .attr('fill', lineColor);
  });
}
